import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _classPrivateFieldGet from "@babel/runtime/helpers/classPrivateFieldGet";
import _classPrivateFieldSet from "@babel/runtime/helpers/classPrivateFieldSet";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }

function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }

import { ApolloLink } from '@apollo/client';
import { BrowserPersistence } from '@magento/peregrine/lib/util'; // The name of the header to exchange with the server.

var CACHE_ID_HEADER = 'x-magento-cache-id'; // The key in local storage where we save the cache id

var LOCAL_STORAGE_KEY = 'magento_cache_id';
var storage = new BrowserPersistence();
/**
 * The Magento GraphQL Cache Link class is an ApolloLink that is responsible for
 * Venia sending the proper `x-magento-cache-id` header with each of its GraphQL requests.
 */

var _cacheId = /*#__PURE__*/new WeakMap();

export var MagentoGQLCacheLink = /*#__PURE__*/function (_ApolloLink) {
  _inherits(MagentoGQLCacheLink, _ApolloLink);

  var _super = _createSuper(MagentoGQLCacheLink);

  function MagentoGQLCacheLink() {
    var _this;

    _classCallCheck(this, MagentoGQLCacheLink);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _classPrivateFieldInitSpec(_assertThisInitialized(_this), _cacheId, {
      writable: true,
      value: storage.getItem(LOCAL_STORAGE_KEY) || null
    });

    return _this;
  }

  _createClass(MagentoGQLCacheLink, [{
    key: "setCacheId",
    value: // Any time the cache id needs to be set, update both our internal variable and
    // the value in local storage.
    function setCacheId(value) {
      _classPrivateFieldSet(this, _cacheId, value);

      storage.setItem(LOCAL_STORAGE_KEY, value);
    }
  }, {
    key: "request",
    value: function request(operation, forward) {
      var _this2 = this;

      // Attach the cache header to each outgoing request.
      operation.setContext(function (previousContext) {
        var headers = previousContext.headers;

        var withCacheHeader = _objectSpread({}, headers, _defineProperty({}, CACHE_ID_HEADER, _classPrivateFieldGet(_this2, _cacheId)));

        return _objectSpread({}, previousContext, {
          headers: withCacheHeader
        });
      }); // Update the cache id from each response.

      var updateCacheId = function updateCacheId(data) {
        var context = operation.getContext();
        var response = context.response;
        var responseCacheId = response.headers.get(CACHE_ID_HEADER);

        if (responseCacheId) {
          _this2.setCacheId(responseCacheId);
        } // Purposefully don't modify the result,
        // no other link needs to know about the cache id.


        return data;
      };

      return forward(operation).map(updateCacheId);
    }
  }]);

  return MagentoGQLCacheLink;
}(ApolloLink);
export default function createGqlCacheLink() {
  return new MagentoGQLCacheLink();
}